import PlayCircleFilled from '@mui/icons-material/PlayCircleFilled';
import useStyles from './usePlayerButtonStyles.styles';

export type PlayButtonProps = {
  onClick: () => void;
};

const PlayButton = ({ onClick }: PlayButtonProps) => {
  const classes = useStyles();
  return (
    <button className={classes.button} onClick={onClick}>
      <PlayCircleFilled />
    </button>
  );
};

export default PlayButton;
